'use client';

import React from 'react';
import { outlineIcons, solidIcons, QuestionMarkCircleIcon } from './heroIcons';
import { CustomIcons } from './customIcons';
type IconVariant = 'outline' | 'solid';

interface IconProps {
  name: string; // Changed to string to accept dynamic values
  variant?: IconVariant;
  size?: number;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  // Passthrough for aria-*/data-* and other SVG attributes.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

function Icon({
  name,
  variant = 'outline',
  size = 24,
  className = '',
  onClick,
  disabled = false,
  ...props
}: IconProps) {
  // Solid variant falls back to the outline icon when no solid version is mapped.
  const IconComponent =
    CustomIcons[name] || (variant === 'solid' ? solidIcons[name] : undefined) || outlineIcons[name];
  if (!IconComponent) {
    return (
      <QuestionMarkCircleIcon
        width={size}
        height={size}
        className={`text-muted-foreground ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
        onClick={disabled ? undefined : onClick}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      width={size}
      height={size}
      className={`${disabled ? 'opacity-50 cursor-not-allowed' : onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      onClick={disabled ? undefined : onClick}
      {...props}
    />
  );
}

export default Icon;
